<template id="account-menu">
  <v-menu
      v-model="menuOpen"
      :max-height="600"
      class="account-menu"
      :close-on-content-click="false"
  >
    <template #activator="{ props }">
      <a-btn
        id="tools-menu-btn"
        color="white"
        variant="text"
        class="label-medium"
        :class="mobile ? '' : 'mt-1'"
        :custom-classes="isMobile ? 'mobile-tools-button' : 'fake-inactive'"
        text="TOOLS"
        append-icon="mdi-chevron-down"
        v-bind="props"
      />
    </template>
    <v-list>
      <v-list-item
        v-for="(item, index) in mutableCompanyTools"
        :key="index"
        :to="item.featurePath"
        :class="{'pa-0': groupFeatureCodes.includes(item.featureCode)}"
        class="clickable"
      >
        <v-list-item-title
          v-if="!groupFeatureCodes.includes(item.featureCode)"
          @click="closeMenu(item)"
        >
          {{ item.featureName }}
        </v-list-item-title>

        <v-list-group
          v-else-if="item.featureCode === 'TOURNAMENTS'"
          class="pa-0"
          value="Tournaments"
        >
          <template #activator="{ props }">
            <v-list-item
              v-bind="props"
              @click="loadBrsTournaments"
            >
              <v-list-item-title>{{ item.featureName }}</v-list-item-title>
            </v-list-item>
          </template>

          <v-list-item v-if="tourneysLoading">
            <v-list-item-title>
              <SpinnerInline
                :size="20"
                color="primary"
              />
            </v-list-item-title>
          </v-list-item>

          <v-list-item v-if="!tourneysLoading && tournaments.length === 0">
            <v-list-item-title class="px-1">
              No Active Tournaments
            </v-list-item-title>
          </v-list-item>

          <v-list-item
            v-for="(t, i) in tournaments"
            v-else-if="!tourneysLoading"
            :key="i"
            class="px-3"
            :to="`/tournament/${t.id}`"
            link
            @click="closeMenu(t)"
          >
            <v-list-item-title>{{ t.tournamentName }}</v-list-item-title>
          </v-list-item>
        </v-list-group>
        <v-list-group
          v-else
          class="pa-0"
          value="Databases"
          style="width: 100%"
        >
          <template #activator="{ props }">
            <v-list-item
              v-bind="props"
              @click="loadDatabaseOptions(index)"
            >
              <v-list-item-title>{{ item.featureName }}</v-list-item-title>
            </v-list-item>
          </template>

          <v-list-item
            v-for="(t, i) in databaseOptions"
            :key="i"
            class="px-7"
            :to="`${databasePaths[i]}`"
            link
            @click="closeMenu(t)"
          >
            <v-list-item-title>{{ t }}</v-list-item-title>
          </v-list-item>
        </v-list-group>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script setup>
import constants from '@/helpers/constants'
import SpinnerInline from '@/components/SpinnerInline'
import { getRequest } from '@/helpers/helpers'
import { useRoute, useRouter } from 'vue-router'

import { toRefs, ref, onMounted } from 'vue'
import { useAppStore } from '@/stores/AppStore.js'
import { useDisplay } from 'vuetify'
const { mobile } = useDisplay()

const appStore = useAppStore()
const route = useRoute()
const router = useRouter()

const props = defineProps({
  companyTools: Array,
  isMobile: Boolean
})
const { companyTools, isMobile } = toRefs(props)

const groupFeatureCodes = ['TOURNAMENTS', 'DATABASES']
const tournaments = ref([])
const tourneysLoading = ref(false)
const mutableCompanyTools = ref(companyTools.value)
const headerColor = ref(constants.ENV_COLOR)
const menuOpen = ref(false)
const databaseOptions = ref([])
const databasePaths = ref([])

onMounted(() => {
  filterForParents()
})

const closeMenu = (item) => {
  if (!groupFeatureCodes.includes(item.featureCode)) {
    menuOpen.value = false
  }
}
const loadBrsTournaments = async () => {
  tourneysLoading.value = true
  try {
    const { data } = await getRequest('/tournament/active', 'blueraven')
    tournaments.value = data
    tourneysLoading.value = false
  } catch (e) {
    console.error('*** ERROR ***', e)
    appStore.showSnack('ERROR', 'Error Loading Tournaments')
    tourneysLoading.value = false
  }
}
const loadDatabaseOptions = async (index) => {
  databaseOptions.value = mutableCompanyTools.value[index].childNames
    .slice()
    .reverse()
  databasePaths.value = mutableCompanyTools.value[index].childPaths
    .slice()
    .reverse()
}
const filterForParents = async() => {
  appStore.loading = true
  let filteredTools = [];
  let lastName = " ";
  let hasCommissions = false;
  companyTools.value?.slice().reverse().forEach(x => {
    if (x.featureName !== lastName) {
      if (["Commissions - Closer", "Commissions - Setter", "Commissions - Installation Partner", "Commissions - Dealer"].includes(x.featureName)) {
        if (!hasCommissions) {
          x.featureName = "Commissions";
          filteredTools.push(x);
          hasCommissions = true;
        }
      } else {
        filteredTools.push(x);
      }
      lastName = x.featureName;
    }
  });
  mutableCompanyTools.value = filteredTools.reverse();
  appStore.loading = false
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}

.v-list .v-list-item--active {
  color: var(--v-anchor-base);
  background-color: var(--v-primary-lighten9);
}

.mobile-tools-button {
  padding-left: 8px !important;
  padding-right: 4px !important;
}

.fake-inactive {
  opacity: .6;
}
</style>
